import { FC, useState } from "react";

import { getVisibleHistory } from "../../../../utils/calculateHistoryPagination";
import { formatHistoryDateTime } from "../../../../utils/formatDate";

import ArrowIcon from "../../../../assets/icons/chevron.svg";

import HistoryPagination from "../../../historyPagination/historyPagination";
import { IReportHistoryOptions } from "../../../../types/reportsInterfaces";

interface IHistoryOptions {
  setCurrentHistoryPage: (page: number) => void;
  currentHistoryPage: number;
  filteredHistory: {
    changer: string;
    date: string;
    name: string;
    newValue: string;
    oldValue: string;
    type: { [key: string]: string };
  }[];
  title: string;
}

const historyItemsPerPage = 25;

const AdminHistorySection: FC<IHistoryOptions> = ({
  setCurrentHistoryPage,
  currentHistoryPage,
  filteredHistory,
  title,
}) => {
  const visibleHistory = getVisibleHistory(filteredHistory, currentHistoryPage, historyItemsPerPage);
  const [isVisibleData, setIsVisibleData] = useState<boolean>(true);
  
  return (
    <div
      className={`sectionData sectionData__overflow ${
        isVisibleData ? "sectionData_active" : ""
      }`}
    >
      <div className="history__title_paginationBlock">
        <span className="section__title">{title}</span>
        {filteredHistory.length > historyItemsPerPage && (
          <HistoryPagination
            totalItems={filteredHistory.length}
            onPageChange={(event: number) => setCurrentHistoryPage(event)}
            currentPage={currentHistoryPage}
            itemsPerPage={historyItemsPerPage}
          />
        )}
        <button
          className="sectionData_button"
          onClick={() => setIsVisibleData(!isVisibleData)}
        >
          <img src={ArrowIcon} alt="Custom Indicator" className="icon" />
        </button>
      </div>
      <table className="customerOutlet__data_table">
        <thead className="tunder__thead">
          <tr>
            <th className="tight__history_cell">Дата</th>
            <th className="tight__history_cell">Изменил</th>
            <th className="tight__history_cell">Тип изменения</th>
            <th className="wide__history_cell">Старое значение</th>
            <th className="wide__history_cell"> Новое значение</th>
          </tr>
        </thead>
        <tbody>
          {visibleHistory.map((elem: IReportHistoryOptions, index: number) => (
            <tr key={index}>
              <td className="tight__history_cell">
                {formatHistoryDateTime(elem.date)}
              </td>
              <td className="tight__history_cell">{elem.changer}</td>
              <td className="tight__history_cell">{elem.name}</td>
              <td className="wide__history_cell">{elem.oldValue}</td>
              <td className="wide__history_cell">{elem.newValue}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminHistorySection;
